<template>
  <q-layout view="hHh lpr fff">

    <q-header
      bordered
      class="text-white"
    >
      <q-toolbar>
        <q-btn
          dense
          flat
          round
          icon="menu"
          :aria-label=" left ? 'Open the menu side left' : 'Close the menu side left'  "
          @click="left = !left"
        />

        <q-toolbar-title>
          <q-avatar>
            <img
              alt="abraao.dev logo"
              src="@/assets/logo.png"
            >
          </q-avatar>
          <span class="text-bold q-pl-sm">abraao.dev</span>
        </q-toolbar-title>

        <q-btn
          class="mobile-only"
          dense
          flat
          round
          icon="more_vert"
          :aria-label=" right ? 'Open the menu side right' : 'Close the menu side right'  "
          @click="right = !right"
        />
      </q-toolbar>
    </q-header>

    <q-drawer
      show-if-above
      v-model="left"
      side="left"
      bordered
    >
      <left-menu @closerMenu="left = !left" />
    </q-drawer>

    <q-drawer
      show-if-above
      v-model="right"
      side="right"
      bordered
    >
    </q-drawer>

    <q-page-container>
      <h3 v-show="isProduction" class="fixed-center text-red ">Em construção</h3>
      <router-view />
    </q-page-container>

    <main-footer />

  </q-layout>
</template>

<script>
import LeftMenu from '@/components/layout/LeftMenu'
import MainFooter from '@/components/layout/MainFooter'

export default {
  name: 'MainLayout',
  components: {
    LeftMenu,
    MainFooter
  },
  data () {
    return {
      left: false,
      right: false
    }
  },
  computed: {
    isProduction: function () {
      return process.env.NODE_ENV === 'production'
    }
  }
}
</script>
